/* Fullscreen Functionality */
const getFullscreenElement = () =>
	document.fullscreenElement ||
	(document as any).webkitFullscreenElement ||
	(document as any).mozFullScreenElement ||
	(document as any).msFullscreenElement;

const requestFullscreen = () => {
	const el = (document as any).documentElement;
	if (el.requestFullscreen) return el.requestFullscreen();
	if (el.webkitRequestFullscreen) return el.webkitRequestFullscreen();
	if (el.mozRequestFullScreen) return el.mozRequestFullScreen();
	if (el.msRequestFullscreen) return el.msRequestFullscreen();
};

const exitFullscreen = () => {
	if (document.exitFullscreen) return document.exitFullscreen();
	if ((document as any).webkitExitFullscreen)
		return (document as any).webkitExitFullscreen();
	if ((document as any).mozCancelFullScreen)
		return (document as any).mozCancelFullScreen();
	if ((document as any).msExitFullscreen)
		return (document as any).msExitFullscreen();
};

export const toggleFullscreen = () => {
	if (!getFullscreenElement()) {
		requestFullscreen();
	} else {
		exitFullscreen();
	}
};
